import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicAccordionWithSwitch from "./BasicAccordionWithSwitch";
import ControlledAccordion from "./ControlledAccordion";
import BasicAccordion from "./BasicAccordion";

const AccordionPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Accordion"}
        description={
          "The accordion component allows the user to show and hide sections of related content on a page."
        }
      />
      <Divider light />
      <BasicAccordion />
      <BasicAccordionWithSwitch />
      <ControlledAccordion />
    </Paper>
  );
};

export default AccordionPage;
